module.exports = __webpack_public_path__ + "media/images/social/facebook-94418ad980345b530e66148a40bee927.png";